module.exports = __webpack_public_path__ + "img/Signup-banner.d000d70a.jpg";